import { SerializableAssetIndexLike } from 'outpost';
import { Board } from './board/board.ts';
import { BoardCard } from './board/board-card.ts';

export const SERIALIZABLE_ASSETS: SerializableAssetIndexLike = [Board, BoardCard];